import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { useConfig } from "@megarax/dev-config";
import { MegaraxWebappContainer } from "@megarax/features";
import { Accounts } from "@megarax/iam-accounts";
import { Groups } from "@megarax/iam-groups";
import { MdSecurity } from "react-icons/md";
import { Outlet, Route } from "react-router-dom-v5-compat";

const iamTheme: Theme = createTheme("191");

export const useIamRouter = () => {
  return (
    <Route
      path="/iam"
      element={
        <ThemeProvider theme={iamTheme}>
          <IamMegaraxWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="accounts/*" element={<Accounts />} />
      <Route path="groups/*" element={<Groups />} />
    </Route>
  );
};

const IamMegaraxWebappContainer: React.FC = () => {
  const { config } = useConfig();

  return (
    <MegaraxWebappContainer
      logo={<MdSecurity width="1em" height="1em" />}
      title="Admin"
      subtitle="megarax.net"
      bypassAuth={config.testUser.enabled}
    >
      <Outlet />
    </MegaraxWebappContainer>
  );
};
